import { combineReducers } from "redux";
import new_entry from "../features/admin/manage_pickup_drop/new_entry/Slice";
import assigned_entry from "../features/admin/manage_pickup_drop/assigned_entry/Slice";
import completed_entry from "../features/admin/manage_pickup_drop/completed_entry/Slice";
import cancelled_entry from "../features/admin/manage_pickup_drop/cancelled_entry/Slice";
import ambassador_rejected_entry from "../features/admin/manage_pickup_drop/ambassador_rejected_entry/Slice";

const ManagePickUpDropAdmin = combineReducers({
  new_entry: new_entry,
  assigned_entry: assigned_entry,
  completed_entry: completed_entry,
  cancelled_entry: cancelled_entry,
  ambassador_rejected_entry: ambassador_rejected_entry,
});

export default ManagePickUpDropAdmin;
